import { BaseVue, Component, Prop, Watch } from '@newview/base-web';
import splitPane from 'vue-splitpane';
import propertyEdit from "./PropertyEdit";
import { PropertySchema, ValueType } from "./PropertySchema";

// 1、文本框 2、下拉框 

@Component({
  components: { splitPane, propertyEdit }
})
export default class PropertyGrid extends BaseVue {

  orderNo: string = "orderaz";
  type: string = "property";
  iconSize: number = 16;

  @Prop({ default: () => ([]) })
  schema!: PropertySchema[];

  @Prop({ default: () => ({}) })
  object!: any;

  @Prop({ default: '属性面板' })
  title!: string;

  @Prop({ default:true })
  GridStatus!: boolean; //控制面板状态

  copyObject: any;
  copySchema: PropertySchema[] = [];
  groupShcemas: PropertySchema[] = [];//属性列表

  selectedProperty: PropertySchema = { text: '', name: '', valueType: ValueType.string };
  idIndex: number = 1;

  @Watch('schema', { immediate: false, deep: false })
  schemaChange(item, oldValue) {
    this.parseScheams();
  }

  @Watch('object', { immediate: false, deep: true })
  objectChange(item, oldValue) {
    this.copyObject = JSON.parse(JSON.stringify(item));
  }

  created() {
    this.copyObject = JSON.parse(JSON.stringify(this.object));
    this.parseScheams();

  }

  parseScheams() {
    // this.copySchema = JSON.parse(JSON.stringify(this.schema));
    this.copySchema = this.schema;
    this.idIndex = 1;
    this.groupShcemas = [];
    this.pushSchemas2Groups(this.copySchema, 0);
  }

  pushSchemas2Groups(schemas: PropertySchema[], tabIndex: number, pId: number = 0, parentPath: string = "/", isOpen: boolean = true) {

    for (const item of schemas) {

      this.$set(item, 'id', this.idIndex);
      this.$set(item, 'pId', pId);
      this.$set(item, 'parentPath', parentPath);
      this.$set(item, 'tabIndex', tabIndex);
      this.$set(item, 'isHide', !isOpen);
      this.$set(item, 'isEdit', false);
      this.idIndex += 1;

      if (item.id == 1) {
        this.selectedProperty = item;
      }

      if (item.isGroup) this.$set(item, 'open', true); else this.$set(item, 'open', false);

      this.groupShcemas.push(item);

      if (!this.isNull(item.children)) {
        this.pushSchemas2Groups(item.children!, item.isGroup ? 0 : tabIndex + 1, item.id, `${parentPath}${item.id}/`, item.open);
      }

    }

  }

  getPropertyItemClass(item) {
    return item.isGroup ? 'group-title' : (this.selectedProperty.id == item.id ? 'property-item property-item-selected' : 'property-item')
  }

  changeChildHideStatus(item) {

    if (item.open == false) {
      const childrenShcemas = this.groupShcemas.filter(d => d.parentPath!.indexOf(`/${item.id}/`) != -1);

      for (const child1 of childrenShcemas) {
        child1.isHide = !item.open;
      }
    } else {
      const childrenShcemas = this.groupShcemas.filter(d => d.pId == item.id);
      for (const child2 of childrenShcemas) {
        child2.isHide = !item.open;
        this.changeChildHideStatus(child2);
      }
    }

  }

  onClickTd(item) {
    if (this.selectedProperty) {
      this.$set(this.selectedProperty, 'isEdit', false);
    }
    this.$set(item, 'isEdit', true);
    this.selectedProperty = item;
  }

  onClickDrop(item) {
    item.open = !item.open;
    this.changeChildHideStatus(item);
  }

  onPropertyValueChange(item, value) {

    if (item.change) {
      item.change(value);
    }

    this.$emit('change', item, value);

  }
  
  onCollapse(){
    this.GridStatus=!this.GridStatus;  
    this.$emit("onPPanelToggle",this.GridStatus);
  } 
  getBindObj(schema) {
    const propertyNames = schema.name.split('.');
    let currentObj = this.copyObject; 
    for (let index = 0; index < propertyNames.length; index++) {
      const name = propertyNames[index];
      if (index == propertyNames.length - 1) {
        return currentObj[name];
      } else {
        currentObj = currentObj[name];
      }
    } 
    return "";
  }

  setBindObj(schema, value) {
    const propertyNames = schema.name.split('.');
    let currentObj = this.copyObject; 
    for (let index = 0; index < propertyNames.length; index++) {
      const name = propertyNames[index];
      if (index == propertyNames.length - 1) {
        currentObj[name] = value;
      } else {
        currentObj = currentObj[name];
      }
    }
  }

  getObject() {
    return this.copyObject;
  }

}